import { FC, useEffect, useState } from "react"
import { ChrevonLeftIcon } from "../../../components/MenuIcons/ChevrotLeft"
import '../create.css'
import { useNavigate, useNavigation } from "react-router-dom"
import { useConfig } from "../../Auth/Auth"
import { useAppConfig } from "../../../hooks/useAppConfig"
import { ConfigType } from "../../../contexts/AppConfigContext"
import InputMask from "react-input-mask";
import { Outlet, Route, Routes } from 'react-router-dom'
import { cpf } from "cpf-cnpj-validator";
import { cpfCnpjNoMask } from "../../../functions/mask"
import api from "../../../services/api";
import { usePluginspace } from "../../../hooks/usePluginspace"
import { Loading } from "../../../components/Loading"
import Swal from 'sweetalert2';




const CreateAccount: FC<any> = () => {

    const { getAppConfig } = useAppConfig();
    const { getToken } = usePluginspace();
    const [config, setConfig] = useState<ConfigType | void>();
    const navigate = useNavigate()


    const [maskCpfjCnpj, setmaskCpfjCnpj] = useState("999.999.999-99");

    const [cpfCustomer, setCpfCustomer] = useState("");
    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")
    const [passwordAgain, setPasswordAgain] = useState("")
    const [name, setName] = useState("")
    const [termo, setTermo] = useState(false)

    const [newCustomer, setNewCustomer] = useState(true)

    const [alarmCpf, setAlarmCpf] = useState(false);
    const [alarmEmail, setAlarmEmail] = useState(false);
    const [validarEmailInput, setValidarEmailInput] = useState(false);

    const [loading, setLoading] = useState(true);



    async function findCustomer() {

        if (cpfCustomer === undefined || cpfCustomer[0] === "_" || !cpf.isValid(cpfCustomer)) {
            setAlarmCpf(true);
        } else {
            setAlarmCpf(false);
        }
        setLoading(true);
        const cpfWithouthMask = cpfCnpjNoMask(cpfCustomer);

        await api
            .post(
                `/api/customer/filter`,
                {
                    cpf: cpfWithouthMask,
                },
                {
                    headers: {
                        Authorization: `Bearer ${await getToken()}`,
                    },
                }
            )
            .then(async (response: any) => {
                setLoading(false);
                if (response.data.data.length > 0) {
                    const data = response.data.data[0];

                    if (data.name)
                        setName(data.name);

                    if (data.email)
                        setEmail(data.email);

                    setNewCustomer(false)
                } else {
                    //clearCustomer();
                }
            })
            .catch((err: any) => {
                //  clearCustomer();
                setLoading(false);
                console.log(err);
            });

    }

    async function findCustomerEmail() {
        return await api
            .post(
                `/api/customer/filter_internal`,
                {
                    email: email,
                },
                {
                    headers: {
                        Authorization: `Bearer ${await getToken()}`,
                    },
                }
            )
            .then(async (response: any) => {

                if (response.data.data.length > 0) {

                    return true

                } else {
                    return false
                }
            })
            .catch((err: any) => {
                //  clearCustomer();
                setLoading(false)
                console.log(err);

                return true
            });
    }


    const getConfig = async () => {
        try {
            setLoading(true)
            const config = await getAppConfig()
            setConfig(config)
            setLoading(false)
        } catch (error) {
            console.log(error)
            setLoading(false)
        }

    }


    const cadastro = async () => {
        // verifica ... 

        if (password && password.length < 4) {
            Swal.fire({
                icon: 'warning',
                title: 'Atenção!',
                text: 'Senha muito curta, minimo de 5 caracteres.',
            })
            return
        }

        if (!name || !email || !cpfCustomer || !password || !passwordAgain || !termo) {
            Swal.fire({
                icon: 'warning',
                title: 'Atenção!',
                text: 'Verifique se todos os campos foram preenchidos.',
            })

            setPassword('')
            setPasswordAgain('')
            return
        } else if (password !== passwordAgain) {
            Swal.fire({
                icon: 'warning',
                title: 'Atenção!',
                text: 'As senhas digitadas não são iguais.',
            })
            setPassword('')
            setPasswordAgain('')
            return
        } else {

            setLoading(true);

            const existCustomerWithEmail = await findCustomerEmail();

            if (existCustomerWithEmail && newCustomer) {
                setLoading(false);
                Swal.fire({
                    icon: 'warning',
                    title: 'Atenção!',
                    text: 'Já existe uma conta com esse email.',
                })
                return
            }


            const customer = {
                name: name,
                email: email,
                doc: cpfCnpjNoMask(cpfCustomer),
                cpf: cpfCnpjNoMask(cpfCustomer),
                password: password,
                optinWhatsapp: false,
                gender: ''
            }
            await api
                .post(
                    `/api/customer/new_customer`,
                    customer,
                    {
                        headers: {
                            Authorization: `Bearer ${await getToken()}`,
                        },
                    }
                )
                .then(async (response: any) => {
                    setLoading(false);
                    const data = response.data

                    if (!data) {
                        Swal.fire({
                            icon: 'error',
                            title: 'Erro',
                            text: 'Erro ao realizar o cadastro,tente novamente!',
                        })
                        return
                    }

                    localStorage.setItem('payload', JSON.stringify({ email: email, doc: cpfCustomer }))

                    navigate('validation')

                })
                .catch((err: any) => {
                    Swal.fire({
                        icon: 'error',
                        title: 'Erro',
                        text: 'Erro ao realizar o cadastro,tente novamente!',
                    })
                    setLoading(false);
                    console.log(err);
                });

        }
    }

    function validarEmail(email: string) {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(email);
    }

    useEffect(() => {
        getConfig()
    }, [])


    const handleBlurEmail = () => {
        if (!validarEmail(email) && email !== '') {
            setAlarmEmail(true)
            setEmail('')
        }else{
            setAlarmEmail(false)
        }
    };

    return (
        <>

            <div className="conteudo">
                {loading ? (
                    <div style={{
                        width: '100%',
                        height: 'calc(100vh)',
                        zIndex: "100",
                        position: "absolute",
                        left: '0',
                        top: "0"
                    }}>
                        <Loading
                            type="spinningBubbles"
                            color="#FFF"
                            width={64}
                            height={64}
                        />
                    </div>
                ) : (
                    <>
                        <div className="header">
                            <span>Vamos criar a sua conta!</span>
                        </div>
                        {/* CPF */}
                        <div className="inputs">
                            <div className="headers">
                                <label>CPF</label>
                                <svg xmlns="http://www.w3.org/2000/svg" width="8" height="9" viewBox="0 0 8 9" fill="none">
                                    <circle cx="4" cy="4.5" r="4" fill="#37393D" />
                                </svg>
                            </div>

                            <div className="cpf-Input">
                                <InputMask
                                    className='myinput'
                                    mask={maskCpfjCnpj}
                                    placeholder="123.456.789-00"
                                    type="default"
                                    value={cpfCustomer}
                                    onChange={(event) => setCpfCustomer(event.target.value)}
                                    // onFocus={() => setHideMenu(true)}
                                    onBlur={() => { findCustomer(); }}
                                />

                            </div>
                            {alarmCpf && (
                                <p className="alarm-text">Informe um CPF válido</p>
                            )}
                        </div>
                        {/* Nome */}
                        <div className="inputs">
                            <div className="headers">
                                <label>Nome</label>
                                <svg xmlns="http://www.w3.org/2000/svg" width="8" height="9" viewBox="0 0 8 9" fill="none">
                                    <circle cx="4" cy="4.5" r="4" fill="#37393D" />
                                </svg>
                            </div>

                            <div className="email-Input">
                                <input
                                    className="myinput"
                                    type="default"
                                    placeholder={'Nome'}
                                    value={name}
                                    onChange={(event) => setName(event.target.value)}
                                />

                            </div>
                        </div>

                        {/* Email */}
                        <div className="inputs">
                            <div className="headers">
                                <label>Email</label>
                                <svg xmlns="http://www.w3.org/2000/svg" width="8" height="9" viewBox="0 0 8 9" fill="none">
                                    <circle cx="4" cy="4.5" r="4" fill="#37393D" />
                                </svg>
                            </div>

                            <div className="email-Input">
                                <input
                                    className="myinput"
                                    type="email"
                                    placeholder={'Email'}
                                    value={email}
                                    onBlur={handleBlurEmail}
                                    onChange={(event) => {
                                        setEmail(event.target.value)
                                    }}
                                />

                            </div>
                            {alarmEmail && (
                                <p className="alarm-text">Informe um Email válido</p>
                            )}
                        </div>
                        {/* Senha */}
                        <div className="inputs">
                            <div className="headers">
                                <label>Senha</label>
                                <svg xmlns="http://www.w3.org/2000/svg" width="8" height="9" viewBox="0 0 8 9" fill="none">
                                    <circle cx="4" cy="4.5" r="4" fill="#37393D" />
                                </svg>
                            </div>
                            <div className="password-Input">
                                <input
                                    className="myinput"
                                    type={"password"}
                                    placeholder={"******"}
                                    value={password}
                                    onChange={(event) => setPassword(event.target.value)}
                                />


                            </div>
                        </div>

                        {/* Senha Aggain*/}
                        <div className="inputs">
                            <div className="headers">
                                <label>Repita a Senha</label>
                                <svg xmlns="http://www.w3.org/2000/svg" width="8" height="9" viewBox="0 0 8 9" fill="none">
                                    <circle cx="4" cy="4.5" r="4" fill="#37393D" />
                                </svg>
                            </div>
                            <div className="password-Input">
                                <input
                                    className="myinput"
                                    type={"password"}
                                    placeholder={"******"}
                                    value={passwordAgain}
                                    onChange={(event) => setPasswordAgain(event.target.value)}
                                />


                            </div>
                        </div>
                        {/* TERMO */}
                        <div className="checkbox">
                            <div className="password-Input">
                                <input
                                    className=""
                                    type={"checkbox"}
                                    checked={termo}
                                    onChange={(event) => setTermo(event.target.checked)}
                                />
                            </div>
                            <div className="headers">
                                <span>Aceito os <a>termos de uso</a> do sistema</span>
                            </div>
                        </div>


                        <div className="buttomCadastro">
                            <button
                                style={{
                                    background: config?.webappcolor.backgroundheader ? config?.webappcolor.backgroundheader : "#6E7586",
                                    color: config?.webappcolor.backgroundheader ? config?.webappcolor.fontmenu : "white",
                                    border: "none",
                                }}
                                onClick={() => cadastro()}
                            >Cadastrar</button>
                        </div>

                    </>
                )

                }
            </div >

        </>
    )
}

export { CreateAccount }